export default __webpack_public_path__ + "static/media/audubon-explore.02e6c213.webp";